module.exports = __webpack_public_path__ + "@/assets/img/unionpay.b2a68a35.svg";